﻿<div class="ai-assistant-panel">
  <div class="ai-assistant-header">
    <span class="ai-assistant-dot"></span>
    <span class="ai-assistant-label">{{settings?.Title || 'AI assistant'}}</span>
  </div>

  <div class="ai-assistant-message" [class.ai-assistant-loading]="loading" [innerHTML]="message"></div>
  <div class="ai-assistant-buttons">
    @for (btn of buttons; track btn) {
      <button type="button" class="ai-assistant-btn ai-assistant-btn-{{btn.Icon}}" (click)="navigate(btn.Url)">
        <span class="ai-btn-icon"></span>{{btn.Label}}
      </button>
    }
  </div>
</div>
